import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Creando una nueva oferta',
  subtitle: '¿Cómo obtiene el cliente un artículo gratis?',
  validation: {
    required: 'Por favor, seleccione un tipo de oferta',
  },
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Valor total del pedido',
      description: 'Ej. 10% de descuento en tu pedido al gastar 20 {{currency}}',
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      name: 'Artículos seleccionados',
      description: 'Ej. 10% de descuento en pizzas de 30 cm.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      name: 'Artículos seleccionados',
      description: 'Ej. 1 {{currency}} de descuento en pizzas de 30 cm.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Valor total del pedido',
      description: 'Ej. 1 {{currency}} de descuento en tu pedido al gastar 20 {{currency}}',
    },
    [OFFER_KIND.BOGO]: {
      name: 'Compra 1 y llévate 1 gratis',
      description: 'Ej. Compra 1 pizza y llévate otra gratis. La pizza más barata es la descontada.',
    },
    [OFFER_KIND.BOGO_HALF_PRICE]: {
      name: 'Compra 1 y llévate 1 a mitad de precio',
      description: 'Ej. Compra 1 pizza y llévate otra a mitad de precio; la más barata es la descontada.',
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      name: 'Al comprar otro artículo',
      description: 'Ej. Consigue una bebida gratis al pedir un menú.',
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      name: 'Al gastar un importe fijo en {{currency}}',
      description: 'Ej. Consigue un postre gratis al gastar 20 {{currency}}.',
    },
  },
};
